var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSocialFacebook = function SvgSocialFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.69 4.648v3.304H6v4.04h2.69V24h5.527V11.993h3.708s.347-1.937.516-4.056h-4.203V5.175c0-.413.602-.969 1.198-.969h3.01V0h-4.093C8.553 0 8.69 4.044 8.69 4.648z",
    fill: "currentColor"
  })));
};
export { SvgSocialFacebook as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNOC42OSA0LjY0OHYzLjMwNEg2djQuMDRoMi42OVYyNGg1LjUyN1YxMS45OTNoMy43MDhzLjM0Ny0xLjkzNy41MTYtNC4wNTZoLTQuMjAzVjUuMTc1YzAtLjQxMy42MDItLjk2OSAxLjE5OC0uOTY5aDMuMDFWMGgtNC4wOTNDOC41NTMgMCA4LjY5IDQuMDQ0IDguNjkgNC42NDh6IiBmaWxsPSJjdXJyZW50Q29sb3IiLz48L3N2Zz4=";